export default __webpack_public_path__ + "static/media/Brigand's Belt of the Grasping Wild.6420382e.jpg";